import React, {useContext, useEffect, useRef} from "react";
import {CBContext} from "./CBContext";
import {FormModal, getPatchValues} from "../utils/utils";
import {Box, Button, CircularProgress} from "@mui/material";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import API from "../utils/API";
import {ProgressContext} from "../utils/ProgressContext";
import {Form, Formik} from "formik";
import {commentSchema} from "./validations";
import TextField from "../utils/components/TextField";
import {generalAPI, removeNulls} from "./utils";


async function commentAPI(transactionID, data){
    const response = await API.post(`cbs/${transactionID}/comments/`, data);
    return response.data;
}

export default function CommentForm(){
    const {cbState, cbDispatch} = useContext(CBContext);
    const {modalType, transactionId, status} = cbState.baseData;
    const {handleProgressOpen, handleProgressClose} = useContext(ProgressContext);
    const formikRef = useRef();
    const queryClient = useQueryClient();

    const {data: cbData, isFetching: cbIsFetching} = useQuery(
        ['cbs', cbState.baseData.transactionId],
        () => generalAPI(`cbs/${cbState.baseData.transactionId}/`),
        {
            refetchOnWindowFocus: false,
            retry: false,
            enabled: cbState.baseData.status >= 1,
            select: data => {
                data = removeNulls(data);
                return data;
            }
        }
    );

    useEffect(() => {
        if (!cbState.baseData.pages[cbState.baseData.activeStep].visited && cbData && cbState.baseData.status !== 0 && !cbState.baseData.cloning) {
            cbDispatch({
                type: 'addUpdateFormData',
                data: {'comments': cbData}
            })
        }
    }, [cbData, cbState.baseData.status, cbState.baseData.activeStep, cbState.baseData.pages, cbState.baseData.cloning, cbDispatch]);


    const mutation = useMutation(
        ['cbs', transactionId, 'comments'],
        data => commentAPI(transactionId, data),
        {
            onMutate: () => handleProgressOpen(),
            onSettled: () => handleProgressClose(),
            onSuccess: () => {
                cbDispatch({
                    type: 'addBaseData',
                    data: {modalType: ''}
                });
                queryClient.invalidateQueries(['cbs', cbState.baseData.transactionId])
            }
        }
    )

    const footer = <>
        <Button variant={'outlined'} onClick={() => cbDispatch({
            type: 'addBaseData',
            data: {modalType: ''}
        })}>Close</Button>
        <Button sx={{ml: 3}} disabled={status < 1} onClick={() => formikRef.current.submitForm()} variant={'contained'}>Save</Button>
    </>

    return (
        <>
            <FormModal
                open={modalType === 'comments'}
                title={'Comments'}
                maxWidth={'xl'}
                width={'500px'}
                footer={footer}
            >
                <Formik
                    innerRef={formikRef}
                    initialValues={cbState.formData.comments}
                    validationSchema={commentSchema}
                    enableReinitialize={true}
                    validateOnChange={false}
                    onSubmit={values => mutation.mutate(getPatchValues(cbState.updateData.comments, values))}
                >
                    <Form>
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '16px',
                                left: '150px'
                            }}
                        >
                            {cbIsFetching && <CircularProgress size={'2rem'}/>}
                        </Box>
                        <TextField
                            name={'comments'}
                            label={'Comments'}
                            fullWidth
                            multiline
                            rows={4}
                            disabled={status < 1}
                        />
                    </Form>
                </Formik>
            </FormModal>
        </>
    )
}